import { TRANSACTION_TYPES } from '@/data/constants/constants'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import useGetTransactions from '@/services/api/cash-flow/transaction/useGetTransactions'
import useAppStore from '@/store/useAppStore'

export default function useGetTransactionByFilter({
  offset,
  vaultId,
  categoryId,
  enabled = true,
  withInitialBalance = false,
  modelId,
  direction,
}: {
  offset: string | number
  vaultId: string | number
  categoryId: string | number
  enabled: boolean
  withInitialBalance?: boolean
  modelId?: string | number
  direction?: 'in' | 'out'
}) {
  const queryClient = useQueryClient()
  const viewPeriodType = useAppStore((state) => state.periodType)
  const viewOffset = useAppStore((state) => state.offset)
  const viewNumberOfPeriods = useAppStore((state) => state.numberOfPeriods)

  const { data: transactions, refetch } = useGetTransactions({
    offset: viewOffset,
    numberOfPeriods: viewNumberOfPeriods,
    periodType: viewPeriodType,
  })

  const fetchData = async () => {
    const { data: _transactions } = await refetch({ cancelRefetch: false })

    let cachedTransactions = _transactions /// []
    // cachedTransactions = queryClient.getQueryData(['latest-transactions']) ?? []

    const transactions = cachedTransactions
      .filter((x) => (modelId ? x.what_if_id === Number(modelId) : true))
      .filter((x) =>
        withInitialBalance
          ? true
          : [TRANSACTION_TYPES.STANDARD, TRANSACTION_TYPES.TRANSFER].includes(
              x.transaction_type,
            ),
      )
      .filter((x) => (offset ? x.offset === Number(offset) : true))
      .filter((x) => (vaultId ? x.vault_id === Number(vaultId) : true))
      .filter((x) =>
        categoryId ? x.transaction_category_id === Number(categoryId) : true,
      )
      .filter((x) =>
        direction
          ? x.direction ===
            (direction === 'in'
              ? 'MoneyIn'
              : direction === 'out'
                ? 'MoneyOut'
                : x.direction)
          : true,
      )

    return transactions
  }

  return useQuery({
    queryKey: [
      'transactions-cache',
      {
        offset,
        vaultId,
        categoryId,
        withInitialBalance,
        modelId,
        direction,
        viewPeriodType,
        viewOffset,
        viewNumberOfPeriods,
      },
    ],
    queryFn: fetchData,
    // refetchOnMount: 'always',
    // staleTime: Infinity,
    enabled,
    placeholderData: [],
    // gcTime: Infinity,
  })
}
